/* unplugin-vue-components disabled */import { render } from "./AggregateAccount.vue?vue&type=template&id=58787f12&scoped=true&ts=true"
import script from "./AggregateAccount.vue?vue&type=script&lang=ts"
export * from "./AggregateAccount.vue?vue&type=script&lang=ts"

import "./AggregateAccount.vue?vue&type=style&index=0&id=58787f12&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58787f12"]])

export default __exports__